// extracted by mini-css-extract-plugin
export default {"container":"Label-module--container--ZXFbQ","inline":"Label-module--inline--pasq3"};